import {useState, useEffect, useMemo} from 'react';
import Select from 'react-select';
import { useTheme } from '@mui/material';

const SelectSubEstadoPreServicio = ({
    id,
    value,
    onChange,
    isInvalid,
    isClearable,
    defaultProps,
    isMulti
}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [selectedValue, setSelectedValue] = useState(value);
    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        onChange(ev);
    };
    const options = [
        {
            value: 'SITUACION CLIMATICA',
            label: 'SITUACION CLIMATICA'
        },
        {
            value: 'PENDIENTE DE EQUIPO',
            label: 'PENDIENTE DE EQUIPO',
        },
        {
            value: 'CANCELADO POR EL CLIENTE',
            label: 'CANCELADO POR EL CLIENTE'
        },
        {
            value: 'PENDIENTE POR MATERIALES/SOPORTE',
            label: 'PENDIENTE POR MATERIALES/SOPORTE',
        },
        {
            value: 'NO SE ENCONTRO EL DOMICILIO',
            label: 'NO SE ENCONTRO EL DOMICILIO'
        },
        {
            value: 'CLIENTE AUSENTE',
            label: 'CLIENTE AUSENTE',
        },
        {
            value: 'CANCELADO POR EL EMPLEADO',
            label: 'CANCELADO POR EL EMPLEADO'
        },
        {
            value: 'POR OPERACIONES',
            label: 'POR OPERACIONES',
        },
        {
            value: 'CORTE DE RUTA',
            label: 'CORTE DE RUTA',
        },
        {
            value: 'POR FALLA DE VEHICULO',
            label: 'POR FALLA DE VEHICULO',
        },
        {
            value: 'ACCIDENTE DEL PERSONAL TECNICO',
            label: 'ACCIDENTE DEL PERSONAL TECNICO',
        },
        {
            value: 'POR AUSENCIA DEL PERSONAL TECNICO',
            label: 'POR AUSENCIA DEL PERSONAL TECNICO',
        },
        {
            value: 'NODO CAIDO',
            label: 'NODO CAIDO',
        },
        {
            value: 'CORTE DE LUZ ZONAL O DOMICILIO',
            label: 'CORTE DE LUZ ZONAL O DOMICILIO',
        },
        {
            value: 'POR CORTE DE ENERGIA ZONAL',
            label: 'POR CORTE DE ENERGIA ZONAL',
        },
        {
            value: 'POR CORTE DE ENERGIA EN EL DOMICILIO',
            label: 'POR CORTE DE ENERGIA EN EL DOMICILIO',
        },
        {
            value: 'POR PRIORIDAD TAREAS',
            label: 'POR PRIORIDAD TAREAS',
        },
        {
            value: 'NO HAY UN PLAN ADECUADO PARA MI',
            label: 'NO HAY UN PLAN ADECUADO PARA MI',
        },
        {
            value: 'ME RESULTA CARO',
            label: 'ME RESULTA CARO',
        },
        {
            value: 'NO TENGO APURO EN CONTRATAR EL SERVICIO',
            label: 'NO TENGO APURO EN CONTRATAR EL SERVICIO',
        },
        {
            value: 'NO LE TENGO CONFIANZA',
            label: 'NO LE TENGO CONFIANZA',
        },
        {
            value: 'NO ME ASESORARON CORRECTAMENTE',
            label: 'NO ME ASESORARON CORRECTAMENTE',
        },
        {
            value: 'NECESITO CONSULTARLO CON OTRA PERSONA',
            label: 'NECESITO CONSULTARLO CON OTRA PERSONA',
        },
        {
            value: 'OTROS',
            label: 'OTROS',
        },
        {
            value: 'ESTOY CONSULTANDO PRECIOS/PROMOCIONES',
            label: 'ESTOY CONSULTANDO PRECIOS/PROMOCIONES',
        },
        {
            value: 'NO TIENEN PROMOCIONES',
            label: 'NO TIENEN PROMOCIONES',
        },
        {
            value: 'NO TIENE SERVICIOS ADICIONALES',
            label: 'NO TIENE SERVICIOS ADICIONALES',
        },
        {
            value: 'NO TENGO TC',
            label: 'NO TENGO TC',
        },
        {
            value: 'NO COTIZAN EN MONEDA NACIONAL',
            label: 'NO COTIZAN EN MONEDA NACIONAL',
        },
        {
            value: 'PLAZO DE ESPERA EN FECHA DE INSTALACION',
            label: 'PLAZO DE ESPERA EN FECHA DE INSTALACION',
        },
        {
            value: 'CANCELADO POR EL CLIENTE',
            label: 'CANCELADO POR EL CLIENTE'
        },
        {
            value: 'CANCELADO POR FALTA DE DOCUMENTACIÓN',
            label: 'CANCELADO POR FALTA DE DOCUMENTACIÓN'
        },
        {
            value: 'AUSENCIA',
            label: 'AUSENCIA',
        },
        {
            value: 'CABLE EN MAL ESTADO',
            label: 'CABLE EN MAL ESTADO',
        },
        {
            value: 'CAJA EN MAL ESTADO',
            label: 'CAJA EN MAL ESTADO',
        },
        {
            value: 'FALTA DE MANTENIMIENTO',
            label: 'FALTA DE MANTENIMIENTO',
        },
        {
            value: 'PUERTOS COMPLETOS',
            label: 'PUERTOS COMPLETOS',
        },
        {
            value: 'SIN HERRAJES',
            label: 'SIN HERRAJES',
        },
        {
            value: 'SIN POTENCIA',
            label: 'SIN POTENCIA',
        },
        {
            value: 'FALTA DE POSTE',
            label: 'FALTA DE POSTE',
        },
        {
            value: 'POSTE EN MAL ESTADO',
            label: 'POSTE EN MAL ESTADO',
        },
        {
            value: 'OBRA COMPLEMENTARIA',
            label: 'OBRA COMPLEMENTARIA',
        },
        {
            value: 'EXCEDE CABLE DROP',
            label: 'EXCEDE CABLE DROP',
        },
        {
            value: 'TIEMPO DE ESPERA',
            label: 'TIEMPO DE ESPERA',
        },
        {
            value: 'NO CUENTA CON TARJETA DE CREDITO',
            label: 'NO CUENTA CON TARJETA DE CREDITO',
        },
        {
            value: 'NO BRINDA MOTIVO',
            label: 'NO BRINDA MOTIVO',
        },
        {
            value: 'CLIENTE NO CONTESTA',
            label: 'CLIENTE NO CONTESTA',
        },
        {
            value: 'CONTRATA OTRO PROVEEDOR - COMBO DE SERVICIOS',
            label: 'CONTRATA OTRO PROVEEDOR - COMBO DE SERVICIOS',
        },
        {
            value: 'CONTRATA OTRO PROVEEDOR - DESCUENTOS/PROMOCIONES',
            label: 'CONTRATA OTRO PROVEEDOR - DESCUENTOS/PROMOCIONES',
        },
        {
            value: 'CONTRATA OTRO PROVEEDOR - PRECIO MAS BAJO',
            label: 'CONTRATA OTRO PROVEEDOR - PRECIO MAS BAJO',
        },
        {
            value: 'CONTRATA OTRO PROVEEDOR - SERVICIOS ADICIONALES',
            label: 'CONTRATA OTRO PROVEEDOR - SERVICIOS ADICIONALES',
        },
        {
            value: 'CONTRATA OTRO PROVEEDOR - MAYOR VELOCIDAD',
            label: 'CONTRATA OTRO PROVEEDOR - MAYOR VELOCIDAD',
        },
        {
            value: 'PRE-SERVICIO DUPLICADO',
            label: 'PRE-SERVICIO DUPLICADO',
        },
        {
            value: 'POR FIN DE TURNO - TECNICO',
            label: 'POR FIN DE TURNO - TECNICO',
        },
        {
            value: 'POR FECHA ADELANTADA',
            label: 'POR FECHA ADELANTADA',
        },
        {
            value: 'POR RETIRO PARCIAL - EQUIPO AUSENTE',
            label: 'POR RETIRO PARCIAL - EQUIPO AUSENTE',
        },
        {
            value: 'POR EQUIPO AUSENTE',
            label: 'POR EQUIPO AUSENTE',
        },
        {
            value: 'POR TRABAJO INTERNO FO',
            label: 'POR TRABAJO INTERNO FO',
        },
    ];

    useEffect(() => {
        if (typeof value === 'string') {
            setSelectedValue(options.find((opt) => opt.value === value));
        }else if(Array.isArray(value)){
            setSelectedValue(value.map(va=>{
                const item = options.find(it=>it.value === va);
                if(item){
                    return {
                        value:item.value,
                        label:item.label
                    };
                }
                return null
            }))
        }
    }, [value]);
    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        menu: (base) => ({
            ...base,
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
            border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e0e0e0'
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected 
                ? (isDarkMode ? '#90caf9' : '#fff')
                : (isDarkMode ? '#e0e0e0' : '#000'),
            background: state.isSelected 
                ? (isDarkMode ? '#1a3a5c' : '#0364ff')
                : (isDarkMode ? '#2d3a52' : '#fff'),
            '&:hover': {
                backgroundColor: isDarkMode ? '#3d4a62' : '#02378c',
                color: isDarkMode ? '#e0e0e0' : '#e0e0e0',
            },
        }),
        control: (styles) => ({
            ...styles,
            borderRadius: 7,
            borderColor: isDarkMode ? '#3d4a62' : 'gray',
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
            '&:hover': {
                borderColor: isDarkMode ? '#64B5F6' : '#0364ff'
            }
        }),
        singleValue: (provided) => ({
            ...provided,
            color: isDarkMode ? '#e0e0e0' : '#000'
        }),
        input: (provided) => ({
            ...provided,
            color: isDarkMode ? '#e0e0e0' : '#000'
        }),
        placeholder: (provided) => ({
            ...provided,
            color: isDarkMode ? '#b0bec5' : 'gray'
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: isDarkMode ? '#1a3a5c' : '#0364ff',
                borderRadius: 5
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        })
    }), [isDarkMode])
    return (
        <Select
            {...defaultProps}
            inputId={id}
            className={`react-select-container ${
                isInvalid ? 'is-invalid' : ''
            }`}
            styles={customStyles}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            placeholder="Seleccione..."
            options={options}
            value={selectedValue}
            onChange={onSelectValue}
            isClearable={isClearable}
            isMulti={isMulti}
            menuShouldScrollIntoView
            menuPosition='absolute'
            menuPlacement='auto'
        />
    );
};

SelectSubEstadoPreServicio.defaultProps = {
    isClearable: false,
    value: null
};

export default SelectSubEstadoPreServicio;